// frontend/util/summary-plans.js
import _ from 'lodash'

// #721 round 2 (spec §6, D23): which of a summary's plans are the client's
// CURRENT plans. Verified ids on the recommendation win; before the advisor
// confirms, the store's guess (resolver id or name match) stands in. Current
// plans stay in the summary's plan set (the renderers price them and the keep
// combos need them) but the sidebar lists them under Current Plans only.

export function currentPlanIds (recommendation, guess) {
    const cur = recommendation?.current
    if (cur) {
        return [cur.supp_id, cur.pdp_id, cur.mapd_id].filter(id => id != null)
    }
    return Object.values(guess || {}).filter(Boolean).map(g => g.id)
}

export function isCurrentPlan (plan, ids) {
    return (ids || []).includes(plan?.id)
}

export function potentialPlans (plans, ids) {
    return (plans || []).filter(p => !isCurrentPlan(p, ids))
}

// The carrier and plan name the survey holds for a line. The renewal step
// stores a label that already starts with a one-word carrier ("Wellcare Value
// Script (PDP)"), so the carrier is shown once.
export function planOnFile (survey, kind) {
    const carrier = (survey?.[`${kind}_carrier`] || '').trim()
    const name = (survey?.[`${kind}_name`] || '').trim()
    if (carrier && name && name.toLowerCase().startsWith(carrier.toLowerCase())) { return name }
    return [carrier, name].filter(Boolean).join(' ')
}

// A plan search query as a literal, case-insensitive match. Stored labels
// carry regex metacharacters ("Wellcare Value Script (PDP)"), and the AEP
// builder runs the name on file as the initial query (review I2).
export function planQueryRe (query) {
    return new RegExp(_.escapeRegExp(query || ''), 'i')
}
